'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var SubscriptionEmptyView = require('modules/settings/views/partials/subscription/empty');
var SubscriptionPlanView = require('modules/settings/views/partials/subscription/plan');
var SubscriptionPaymentMethodView = require('modules/settings/views/partials/subscription/payment-method');
var SubscriptionBillingAddressView = require('modules/settings/views/partials/subscription/billing-address');
var SubscriptionReceiptListView = require('modules/settings/views/partials/subscription/receipt-list');
var QuotaView = require('modules/settings/views/partials/quota');

var template = require('modules/settings/templates/layout/subscription.hbs');

var SubscriptionLayout = LayoutView.extend({
    template: template,

    className: 'settings settings-subscription',

    regions: {
        emptyRegion: '.subscription-details-empty-region',
        planDisplayRegion: '.subscription-details-plan-display-region',
        paymentMethodDisplayRegion: '.subscription-details-payment-method-display-region',
        billingAddressDisplayRegion: '.subscription-details-billing-address-display-region',
        receiptListRegion: '.subscription-details-receipt-list-region',
        quotaRegion: '.subscription-details-quota-region',
    },

    modelEvents: {
        'change': 'render',
    },

    onRender: function() {
        if (this.model.get('subscriptionActive') === true) {
            this.planDisplayRegion.show(new SubscriptionPlanView({
                model: this.model,
            }));

            this.paymentMethodDisplayRegion.show(new SubscriptionPaymentMethodView({
                model: this.model,
            }));

            this.billingAddressDisplayRegion.show(new SubscriptionBillingAddressView({
                model: this.model,
            }));

            this.receiptListRegion.show(new SubscriptionReceiptListView({
                collection: this.getOption('receiptsCollection'),
            }));
        } else {
            this.emptyRegion.show(new SubscriptionEmptyView({
                model: this.model,
            }));
        }

        this.quotaRegion.show(new QuotaView({
            model: App.user,
        }))
    },
});

module.exports = SubscriptionLayout;